import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import OpenRoadsService from "../services/OpenRoadsService";

const useOpenRoadsService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new OpenRoadsService(client);
  }, [client]);

  return service;
};

export default useOpenRoadsService;
